// extracted by mini-css-extract-plugin
export default {"root":"RmHJ5fWjiLYGxYWiHBY7","wrap":"oaImaAw8whrSQ3G2Z5bD"};